type Format = {
    date: Record<string, string>,
    time: Record<string, string>,
};

const FORMATS: Record<string, Format> = {
    YYYYMMDD: {
        date: {
            NUMERIC: 'YYYY-MM-DD',
            WORD: 'YYYY MMM, DD',
            FILE_NAME: 'YYYY_MM_DD',
            CALENDAR: 'yyyy-MM-dd',
        },
        time: {
            NUMERIC: 'HH:mm',
            WORD: 'hh:mm A',
            FILE_NAME: 'H_mm_ss',
        },
    },
    DDMMYYYY: {
        date: {
            NUMERIC: 'DD-MM-YYYY',
            WORD: 'DD MMM, YYYY',
            FILE_NAME: 'DD_MM_YYYY',
            CALENDAR: 'dd-MM-yyyy',
        },
        time: {
            NUMERIC: 'HH:mm',
            WORD: 'hh:mm A',
            FILE_NAME: 'H_mm_ss',
        },
    },
    MMDDYYYY: {
        date: {
            NUMERIC: 'MM-DD-YYYY',
            WORD: 'MMM DD, YYYY',
            FILE_NAME: 'MM_DD_YYYY',
            CALENDAR: 'MM-dd-yyyy',
        },
        time: {
            NUMERIC: 'HH:mm',
            WORD: 'hh:mm A',
            FILE_NAME: 'H_mm_ss',
        },
    },
};

export const mapDateFormat = (
    dateFormat: string,
    monthView: 'NUMERIC' | 'WORD' | 'FILE_NAME' | 'CALENDAR',
    options: 'DATE' | 'TIME' | 'DATE_TIME' = 'DATE',
) => {
    const format = FORMATS[dateFormat];

    if (!format) {
        return 'invalid format';
    }

    const resultDate = format.date[monthView];
    const resultTime = format.time[monthView];

    switch (options) {
        case 'DATE':
            return resultDate;
        case 'TIME':
            return resultTime;
        case 'DATE_TIME':
            return `${resultDate} [at] ${resultTime}`;
        default:
            return resultDate;
    }
};
